module.exports = __webpack_public_path__ + "img/GY.5bfac901.svg";